module.exports = __webpack_public_path__ + "media/Tractor.48cc0dd7.ogg";